import type { SVGProps } from "react";

export function IconBlueWaveDollar(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 21V5.5L3.31094 5.15451C5.69374 2.50696 9.6889 2.08087 12.5765 4.16634C14.9358 5.87033 18.1054 5.92974 20.527 4.31536L21 4V21H3Z"
        fill="#5486FA"
        stroke="#5486FA"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M9.5 14.25C9.5 14.5961 9.64662 14.9345 9.92133 15.2222C10.196 15.51 10.5865 15.7343 11.0433 15.8668C11.5001 15.9992 12.0028 16.0339 12.4877 15.9664C12.9727 15.8989 13.4181 15.7322 13.7678 15.4874C14.1174 15.2427 14.3555 14.9309 14.452 14.5914C14.5484 14.2519 14.4989 13.9001 14.3097 13.5803C14.1205 13.2605 13.8 12.9872 13.3889 12.7949C12.9778 12.6026 12.4945 12.5 12 12.5C11.5055 12.5 11.0222 12.3974 10.6111 12.2051C10.2 12.0128 9.87952 11.7395 9.6903 11.4197C9.50108 11.0999 9.45157 10.7481 9.54804 10.4086C9.6445 10.0691 9.8826 9.75731 10.2322 9.51256C10.5819 9.26782 11.0273 9.10115 11.5123 9.03363C11.9972 8.9661 12.4999 9.00076 12.9567 9.13321C13.4135 9.26567 13.804 9.48997 14.0787 9.77775C14.3534 10.0655 14.5 10.4039 14.5 10.75M12 17.75V16M12 9V7.25"
        stroke="#0B0D17"
        strokeWidth="1.5"
      />
    </svg>
  );
}
